import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { List } from 'immutable';

import UnmatchedIcon from '../../../../images/icons/misc/icon-betslip.svg';
import Offers from '../../../containers/betslip/Offers';
import ActiveBets from '../../../containers/betslip/ActiveBets';
import BetBuilderBets from '../../../containers/betslip/BetBuilderBets';
// import SettledBets from '../../../containers/betslip/SettledBets/SettledBets';
import NewButtons from '../../../containers/betslip/NewButtons';
import Button from '@xanadu/ui-shared/components/widgets/Button';

import styles from './Tabs.module.scss';

const Tabs = ({
  className,
  unsubmittedOffers,
  openOffers,
  // betslipSettledBets,
  updateUnsubmittedOfferByCid,
  updateOfferByUser,
  submitEditedOffersByIds,
  reviewUnsubmittedOffer,
  reviewOpenOffer,
  submitOffers,
  // oddsType,
  mainContent,
  onUpdateTabActive,
  betBuilderRestricted
}) => {
  const [activeTabLink, setActiveTabLink] = useState(
    unsubmittedOffers.size > 0 ? 'betslip' : 'active-bets'
  );

  const [showSettings, setShowSettings] = useState(false);
  const unsubmittedOffersBadgeElement = useRef(null);
  const openOffersBadgeElement = useRef(null);
  const betsBadgeElement = useRef(null);

  useEffect(() => {
    if (unsubmittedOffers.size === 0 && mainContent === 'betslip') {
      setActiveTabLink('active-bets');
    } else {
      setActiveTabLink(mainContent);
    }
  }, [unsubmittedOffers.size, mainContent]);

  const handleBadgesAnimation = ({
    unsubmittedOffers: newUnsubmittedOffers,
    openOffers: newOpenOffers,
    // betslipSettledBets: newBetslipSettledBets
  }) => {
    const animateBadgeClass = styles['badge--animate'];

    const animateBadge = (element, size) => {
      if (element && size > -1) {
        element.classList.add(animateBadgeClass);
      }
    };

    animateBadge(unsubmittedOffersBadgeElement.current, newUnsubmittedOffers.size);
    animateBadge(openOffersBadgeElement.current, newOpenOffers.size);
    // animateBadge(betsBadgeElement.current, newBetslipSettledBets.size);

    setTimeout(() => {
      if (unsubmittedOffersBadgeElement.current) {
        unsubmittedOffersBadgeElement.current.classList.remove(animateBadgeClass);
      }
      if (openOffersBadgeElement.current) {
        openOffersBadgeElement.current.classList.remove(animateBadgeClass);
      }
      if (betsBadgeElement.current) {
        betsBadgeElement.current.classList.remove(animateBadgeClass);
      }
    }, 250);
  };

  useEffect(() => {
    handleBadgesAnimation({ unsubmittedOffers, openOffers });
  }, [unsubmittedOffers, openOffers]);
  // useEffect(() => {
  //   handleBadgesAnimation({ unsubmittedOffers, openOffers, betslipSettledBets });
  // }, [unsubmittedOffers, openOffers, betslipSettledBets]);

  const handleActiveTabLink = (newActiveTabLink) => {
    onUpdateTabActive(newActiveTabLink);
    setActiveTabLink(newActiveTabLink);
  };

  const isUnmatchedBet = openOffers.some((offer) => ['open', 'edited'].includes(offer.status)) ? (
    <UnmatchedIcon />
  ) : null;

  const handleSettings = (newSettings) => {
    setShowSettings(newSettings);
  };

  let content;
  let buttons;

  switch (activeTabLink) {
    case 'active-bets':
      content = (
        <ActiveBets
          status="unmatched"
          key="unmatched"
          showSettings={showSettings}
        />
      );
      buttons = (
        <NewButtons
          onUpdateOffers={updateOfferByUser}
          onSubmitOffers={submitEditedOffersByIds}
          onReviewOffer={reviewOpenOffer}
          offers={openOffers}
          activeTab="unmatched"
          handleSettings={handleSettings}
          showSettings={showSettings}
        />
      );
      break;
    case 'bet-builder':
      content = (
        <BetBuilderBets
          status="bet-builder"
          key="bet-builder"
          showSettings={showSettings}
        />
      );
      break;
    // case 'settled-bets':
    //   content = <SettledBets oddsType={oddsType} />;
    //   break;
    default:
      content = (
        <Offers
          status="unsubmitted"
          key="unsubmitted"
          showSettings={showSettings}
          handleActiveTabLink={handleActiveTabLink}
        />
      );
      buttons = (
        <NewButtons
          onUpdateOffers={updateUnsubmittedOfferByCid}
          onSubmitOffers={submitOffers}
          onReviewOffer={reviewUnsubmittedOffer}
          offers={unsubmittedOffers}
          activeTab="betslip"
          handleSettings={handleSettings}
          showSettings={showSettings}
        />
      );
  }

  let betslipTabLink = null;
  let unmatchedTabLink = null;
  let betBuilderTablink = null;

  betslipTabLink = (
    <Button
      className={styles.tabLink}
      sizeType="regular"
      buttonType="text"
      disabled={unsubmittedOffers.size === 0}
      onClick={() => handleActiveTabLink('betslip')}
      dataHook="betslip-menu"
    >
      <div className={styles.text}>Place Bets</div>
    </Button>
  );

  unmatchedTabLink = (
    <Button
      className={styles.tabLink}
      sizeType="regular"
      buttonType="text"
      onClick={() => handleActiveTabLink('active-bets')}
      dataHook="betslip-unmatched-menu"
    >
      <div className={styles.text}>Exchange {isUnmatchedBet}</div>
    </Button>
  );

  betBuilderTablink = (
    <Button
      className={styles.tabLink}
      sizeType="regular"
      buttonType="text"
      onClick={() => handleActiveTabLink('bet-builder')}
      dataHook="betslip-builder-menu"
    >
      <div className={styles.text}>Bet Builder</div>
    </Button>
  );

  const activePositionValue = betBuilderRestricted ? '50%' : '33%';

  const activePositions = {
    betslip: {
      width: activePositionValue,
      left: 0,
    },
    'active-bets': {
      width: activePositionValue,
      left: activePositionValue,
    },
    ...(!betBuilderRestricted && {
      'bet-builder': {
        width: '33%',
        left: '66%',
      },
    })

  };

  return (
    <div className={className}>
      <div className={styles.header}>
        {betslipTabLink}
        {unmatchedTabLink}
        {!betBuilderRestricted && betBuilderTablink}
        <div className={styles.active} style={activePositions[activeTabLink]} />
      </div>
      <div className={styles.content}>
        {content}
        {buttons}
      </div>
    </div>
  );
};
Tabs.propTypes = {
  className: PropTypes.string.isRequired,
  unsubmittedOffers: PropTypes.instanceOf(List).isRequired,
  openOffers: PropTypes.instanceOf(List).isRequired,
  // betslipSettledBets: PropTypes.instanceOf(List).isRequired,
  updateUnsubmittedOfferByCid: PropTypes.func.isRequired,
  updateOfferByUser: PropTypes.func.isRequired,
  submitEditedOffersByIds: PropTypes.func.isRequired,
  reviewUnsubmittedOffer: PropTypes.func.isRequired,
  reviewOpenOffer: PropTypes.func.isRequired,
  submitOffers: PropTypes.func.isRequired,
  // oddsType: PropTypes.string,
  mainContent: PropTypes.string,
  onUpdateTabActive: PropTypes.func.isRequired,
  betBuilderRestricted: PropTypes.bool.isRequired

};

export default Tabs;
